import { render, staticRenderFns } from "./ReportItems.vue?vue&type=template&id=632ee424&scoped=true"
import script from "./ReportItems.vue?vue&type=script&lang=js"
export * from "./ReportItems.vue?vue&type=script&lang=js"
import style0 from "./ReportItems.vue?vue&type=style&index=0&id=632ee424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ee424",
  null
  
)

export default component.exports